// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"black-friday-banner_saveTag__37V1f","text":"black-friday-banner_text__ZQzjO"};